


export const navbar_data = [
    {
        id: "1",
        name: "Home",
        link: "/",
    },
    {
        id: "2",
        name: "Insured protocols",
        link: "/protocols"
    },
    {
        id: "3",
        name: "Claims",
        link: "/claims"
    },
]